import { create } from "zustand";

import { getAccessToken } from "@/utils/storageService";

type AuthStore = {
  isAuthorized: boolean;
  setIsAuthorized: (value: boolean) => void;
};

const useAuthStore = create<AuthStore>((set) => ({
  isAuthorized: !!getAccessToken(),
  setIsAuthorized: (isAuthorized) => set(() => ({ isAuthorized })),
}));

export default useAuthStore;
